'use client';
import React from 'react';
import styles from './FuturisticStatCircle.module.scss';

type Props = {
    value: number;
    label: string;
};

const FuturisticStatCircle = ({ value, label }: Props) => (
    <div className={styles.circleContainer}>
        <div className={styles.circleGlow} />
        <div className={styles.content}>
            <div className={styles.value}>{value}</div>
            <div className={styles.label}>{label}</div>
        </div>
    </div>
);

export default FuturisticStatCircle;
